import { render, staticRenderFns } from "./ProtocolQuestion.vue?vue&type=template&id=c961a3d8&lang=pug"
import script from "./ProtocolQuestion.vue?vue&type=script&lang=js"
export * from "./ProtocolQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports